import { LocationQueryValue } from "vue-router";
import cloneDeep from "lodash-es/cloneDeep";
import { QueryParam } from "~/modules/helpers/composables/useQueryParams/classes/QueryParam";
import { QueryParamsType } from "~/modules/helpers/composables";
import { ZaprooKlevuFilterManager } from "~/modules/klevu/classes/ZaprooKlevuFilterManager";

export class QueryParamKlevuFilterManager extends QueryParam<
  ZaprooKlevuFilterManager,
  string
> {
  type = QueryParamsType.str;

  constructor() {
    super();
    this.default = () => new ZaprooKlevuFilterManager();
    this.value.value = this.getDefault();
  }

  override parse(
    queryVariable: LocationQueryValue | LocationQueryValue[] | undefined,
  ) {
    this.fromQueryVariable((queryVariable as string) || "");
  }

  override getUnrefValue(): ZaprooKlevuFilterManager | undefined {
    return new ZaprooKlevuFilterManager({
      filters: cloneDeep(this.value.value?.filters),
    });
  }

  protected fromQueryVariable(
    val: string | string[],
  ): ZaprooKlevuFilterManager | undefined {
    this.value.value?.reset();
    val = Array.isArray(val) ? val[0] || "" : val || "";
    this.value.value?.readFromURLParams(new URLSearchParams(val));
    return this.value.value;
  }

  toRaw(): string | undefined {
    return this.value.value?.toURLParams();
  }
}
